/* eslint-disable */
import { PluginContainerData, Link, Gradient } from './common.js';

import { ButtonData_Type, ButtonData_Styles_Background_Type } from './plugin_button.enums.js';

export interface ButtonData {
  /** Styling for the button's container. */
  containerData?: PluginContainerData;
  /** The button type. */
  type: ButtonData_Type;
  /** Styling for the button. */
  styles?: ButtonData_Styles;
  /** The text to display on the button. */
  text?: string;
  /** Button link details. */
  link?: Link;
}

export function buttonData_TypeFromJSON(object: any): ButtonData_Type {
  switch (object) {
    case 0:
    case "LINK":
      return ButtonData_Type.LINK;
    case 1:
    case "ACTION":
      return ButtonData_Type.ACTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ButtonData_Type.UNRECOGNIZED;
  }
}

export function buttonData_TypeToJSON(object: ButtonData_Type): string {
  switch (object) {
    case ButtonData_Type.LINK:
      return "LINK";
    case ButtonData_Type.ACTION:
      return "ACTION";
    default:
      return "UNKNOWN";
  }
}

export interface ButtonData_Styles {
  /**
   * Deprecated: Use `borderWidth` and `borderRadius` instead.
   *
   * @deprecated
   */
  border?: ButtonData_Styles_Border;
  /**
   * Deprecated: Use `textColor`, `borderColor` and `backgroundColor` instead.
   *
   * @deprecated
   */
  colors?: ButtonData_Styles_Colors;
  /** Border width in pixels. */
  borderWidth?: number;
  /**
   * Deprecated: Use `borderWidth` for normal/hover states instead.
   *
   * @deprecated
   */
  borderWidthHover?: number;
  /** Border radius in pixels. */
  borderRadius?: number;
  /** Border color as a hexadecimal value. */
  borderColor?: string;
  /** Border color as a hexadecimal value (hover state). */
  borderColorHover?: string;
  /** Text color as a hexadecimal value. */
  textColor?: string;
  /** Text color as a hexadecimal value (hover state). */
  textColorHover?: string;
  /**
   * Deprecated: Use `background` instead.
   *
   * @deprecated
   */
  backgroundColor?: string;
  /**
   * Deprecated: Use `backgroundHover` instead.
   *
   * @deprecated
   */
  backgroundColorHover?: string;
  /** Button size option, one of `SMALL`, `MEDIUM` or `LARGE`. Defaults to `MEDIUM`. */
  buttonSize?: string;
  /** Background styling (color or gradient). */
  background?: ButtonData_Styles_Background;
  /** Background styling for hover state (color or gradient). */
  backgroundHover?: ButtonData_Styles_Background;
}

export interface ButtonData_Styles_Colors {
  /**
   * Deprecated: Use `textColor` in `styles` instead.
   *
   * @deprecated
   */
  text?: string;
  /**
   * Deprecated: Use `borderColor` in `styles` instead.
   *
   * @deprecated
   */
  border?: string;
  /**
   * Deprecated: Use `backgroundColor` in `styles` instead.
   *
   * @deprecated
   */
  background?: string;
}

export interface ButtonData_Styles_Border {
  /**
   * Deprecated: Use `borderWidth` in `styles` instead.
   *
   * @deprecated
   */
  width?: number;
  /**
   * Deprecated: Use `borderRadius` in `styles` instead.
   *
   * @deprecated
   */
  radius?: number;
}

/** Background styling (color or gradient) */
export interface ButtonData_Styles_Background {
  /** Background type. */
  type: ButtonData_Styles_Background_Type;
  /** Background color as a hexadecimal value. */
  color?: string;
  /** Gradient configuration. */
  gradient?: Gradient;
}

export function buttonData_Styles_Background_TypeFromJSON(
  object: any
): ButtonData_Styles_Background_Type {
  switch (object) {
    case 0:
    case "COLOR":
      return ButtonData_Styles_Background_Type.COLOR;
    case 1:
    case "GRADIENT":
      return ButtonData_Styles_Background_Type.GRADIENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ButtonData_Styles_Background_Type.UNRECOGNIZED;
  }
}

export function buttonData_Styles_Background_TypeToJSON(
  object: ButtonData_Styles_Background_Type
): string {
  switch (object) {
    case ButtonData_Styles_Background_Type.COLOR:
      return "COLOR";
    case ButtonData_Styles_Background_Type.GRADIENT:
      return "GRADIENT";
    default:
      return "UNKNOWN";
  }
}

const baseButtonData: object = { type: ButtonData_Type.LINK };

export const ButtonData = {
  fromJSON(object: any): ButtonData {
    const message = { ...baseButtonData } as ButtonData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.type =
      object.type !== undefined && object.type !== null
        ? buttonData_TypeFromJSON(object.type)
        : ButtonData_Type.LINK;
    message.styles =
      object.styles !== undefined && object.styles !== null
        ? ButtonData_Styles.fromJSON(object.styles)
        : undefined;
    message.text =
      object.text !== undefined && object.text !== null
        ? String(object.text)
        : undefined;
    message.link =
      object.link !== undefined && object.link !== null
        ? Link.fromJSON(object.link)
        : undefined;
    return message;
  },

  toJSON(message: ButtonData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.type !== undefined &&
      (obj.type = buttonData_TypeToJSON(message.type));
    message.styles !== undefined &&
      (obj.styles = message.styles
        ? ButtonData_Styles.toJSON(message.styles)
        : undefined);
    message.text !== undefined && (obj.text = message.text);
    message.link !== undefined &&
      (obj.link = message.link ? Link.toJSON(message.link) : undefined);
    return obj;
  },
};

const baseButtonData_Styles: object = {};

export const ButtonData_Styles = {
  fromJSON(object: any): ButtonData_Styles {
    const message = { ...baseButtonData_Styles } as ButtonData_Styles;
    message.border =
      object.border !== undefined && object.border !== null
        ? ButtonData_Styles_Border.fromJSON(object.border)
        : undefined;
    message.colors =
      object.colors !== undefined && object.colors !== null
        ? ButtonData_Styles_Colors.fromJSON(object.colors)
        : undefined;
    message.borderWidth =
      object.borderWidth !== undefined && object.borderWidth !== null
        ? Number(object.borderWidth)
        : undefined;
    message.borderWidthHover =
      object.borderWidthHover !== undefined && object.borderWidthHover !== null
        ? Number(object.borderWidthHover)
        : undefined;
    message.borderRadius =
      object.borderRadius !== undefined && object.borderRadius !== null
        ? Number(object.borderRadius)
        : undefined;
    message.borderColor =
      object.borderColor !== undefined && object.borderColor !== null
        ? String(object.borderColor)
        : undefined;
    message.borderColorHover =
      object.borderColorHover !== undefined && object.borderColorHover !== null
        ? String(object.borderColorHover)
        : undefined;
    message.textColor =
      object.textColor !== undefined && object.textColor !== null
        ? String(object.textColor)
        : undefined;
    message.textColorHover =
      object.textColorHover !== undefined && object.textColorHover !== null
        ? String(object.textColorHover)
        : undefined;
    message.backgroundColor =
      object.backgroundColor !== undefined && object.backgroundColor !== null
        ? String(object.backgroundColor)
        : undefined;
    message.backgroundColorHover =
      object.backgroundColorHover !== undefined &&
      object.backgroundColorHover !== null
        ? String(object.backgroundColorHover)
        : undefined;
    message.buttonSize =
      object.buttonSize !== undefined && object.buttonSize !== null
        ? String(object.buttonSize)
        : undefined;
    message.background =
      object.background !== undefined && object.background !== null
        ? ButtonData_Styles_Background.fromJSON(object.background)
        : undefined;
    message.backgroundHover =
      object.backgroundHover !== undefined && object.backgroundHover !== null
        ? ButtonData_Styles_Background.fromJSON(object.backgroundHover)
        : undefined;
    return message;
  },

  toJSON(message: ButtonData_Styles): unknown {
    const obj: any = {};
    message.border !== undefined &&
      (obj.border = message.border
        ? ButtonData_Styles_Border.toJSON(message.border)
        : undefined);
    message.colors !== undefined &&
      (obj.colors = message.colors
        ? ButtonData_Styles_Colors.toJSON(message.colors)
        : undefined);
    message.borderWidth !== undefined &&
      (obj.borderWidth = message.borderWidth);
    message.borderWidthHover !== undefined &&
      (obj.borderWidthHover = message.borderWidthHover);
    message.borderRadius !== undefined &&
      (obj.borderRadius = message.borderRadius);
    message.borderColor !== undefined &&
      (obj.borderColor = message.borderColor);
    message.borderColorHover !== undefined &&
      (obj.borderColorHover = message.borderColorHover);
    message.textColor !== undefined && (obj.textColor = message.textColor);
    message.textColorHover !== undefined &&
      (obj.textColorHover = message.textColorHover);
    message.backgroundColor !== undefined &&
      (obj.backgroundColor = message.backgroundColor);
    message.backgroundColorHover !== undefined &&
      (obj.backgroundColorHover = message.backgroundColorHover);
    message.buttonSize !== undefined && (obj.buttonSize = message.buttonSize);
    message.background !== undefined &&
      (obj.background = message.background
        ? ButtonData_Styles_Background.toJSON(message.background)
        : undefined);
    message.backgroundHover !== undefined &&
      (obj.backgroundHover = message.backgroundHover
        ? ButtonData_Styles_Background.toJSON(message.backgroundHover)
        : undefined);
    return obj;
  },
};

const baseButtonData_Styles_Colors: object = {};

export const ButtonData_Styles_Colors = {
  fromJSON(object: any): ButtonData_Styles_Colors {
    const message = {
      ...baseButtonData_Styles_Colors,
    } as ButtonData_Styles_Colors;
    message.text =
      object.text !== undefined && object.text !== null
        ? String(object.text)
        : undefined;
    message.border =
      object.border !== undefined && object.border !== null
        ? String(object.border)
        : undefined;
    message.background =
      object.background !== undefined && object.background !== null
        ? String(object.background)
        : undefined;
    return message;
  },

  toJSON(message: ButtonData_Styles_Colors): unknown {
    const obj: any = {};
    message.text !== undefined && (obj.text = message.text);
    message.border !== undefined && (obj.border = message.border);
    message.background !== undefined && (obj.background = message.background);
    return obj;
  },
};

const baseButtonData_Styles_Border: object = {};

export const ButtonData_Styles_Border = {
  fromJSON(object: any): ButtonData_Styles_Border {
    const message = {
      ...baseButtonData_Styles_Border,
    } as ButtonData_Styles_Border;
    message.width =
      object.width !== undefined && object.width !== null
        ? Number(object.width)
        : undefined;
    message.radius =
      object.radius !== undefined && object.radius !== null
        ? Number(object.radius)
        : undefined;
    return message;
  },

  toJSON(message: ButtonData_Styles_Border): unknown {
    const obj: any = {};
    message.width !== undefined && (obj.width = message.width);
    message.radius !== undefined && (obj.radius = message.radius);
    return obj;
  },
};

const baseButtonData_Styles_Background: object = {
  type: ButtonData_Styles_Background_Type.COLOR,
};

export const ButtonData_Styles_Background = {
  fromJSON(object: any): ButtonData_Styles_Background {
    const message = {
      ...baseButtonData_Styles_Background,
    } as ButtonData_Styles_Background;
    message.type =
      object.type !== undefined && object.type !== null
        ? buttonData_Styles_Background_TypeFromJSON(object.type)
        : ButtonData_Styles_Background_Type.COLOR;
    message.color =
      object.color !== undefined && object.color !== null
        ? String(object.color)
        : undefined;
    message.gradient =
      object.gradient !== undefined && object.gradient !== null
        ? Gradient.fromJSON(object.gradient)
        : undefined;
    return message;
  },

  toJSON(message: ButtonData_Styles_Background): unknown {
    const obj: any = {};
    message.type !== undefined &&
      (obj.type = buttonData_Styles_Background_TypeToJSON(message.type));
    message.color !== undefined && (obj.color = message.color);
    message.gradient !== undefined &&
      (obj.gradient = message.gradient
        ? Gradient.toJSON(message.gradient)
        : undefined);
    return obj;
  },
};
